import {
  PermissionGroup,
  PredefinedBasedOnRole,
  SystemPermissionGroup,
} from '@ardoq/api-types';

export const systemGroupComparator = (
  a: SystemPermissionGroup,
  b: SystemPermissionGroup
): number => {
  const priority: Record<PredefinedBasedOnRole, number> = {
    everyone: 0,
    member: 1,
    contributor: 2,
  };
  return priority[a.predefinedBasedOnRole] - priority[b.predefinedBasedOnRole];
};

export const isSystemGroup = (
  group: PermissionGroup
): group is SystemPermissionGroup => Boolean(group.predefinedBasedOnRole);
